import { memo, useRef } from 'react';
import { ActiveFilter } from '../../crawler/crawler.interface';
import { __formatDateMM_DD_YYYY_US } from '../../utils/dateTimeUtils';
import { RemoveIcon } from '../icons/icons';
import './filterTag.scss';
import { __capitalizeFirstLetter } from 'src/app/utils/utils';

interface FilterTagProps {
    filter: ActiveFilter;
    removeActiveFilter: (filter: ActiveFilter) => void;
}
const FilterTag = ({ filter, removeActiveFilter }: FilterTagProps) => {

    const tagRef = useRef<HTMLDivElement>(null);

    function removeFilter() {
        removeActiveFilter(filter);
        tagRef.current?.classList.add('removing');
    }

    let filterTagBody: JSX.Element;
    switch (filter.name) {
        case 'created_at': {
            const dateRange = filter.value.replace('..', ' - ');
            const dateRanges = dateRange.split(' - ');
            filterTagBody =
                <>
                    <strong>Created Date Range</strong> &nbsp; <p className="filter-text">{__formatDateMM_DD_YYYY_US(dateRanges[0])} - {__formatDateMM_DD_YYYY_US(dateRanges[1])}</p>
                </>;
            break;
        }
        case 'updated_at': {
            const dateRange = filter.value.replace('..', ' - ');
            const dateRanges = dateRange.split(' - ');
            filterTagBody =
                <>
                    <strong>Updated Date Range</strong> &nbsp; <p className="filter-text">{__formatDateMM_DD_YYYY_US(dateRanges[0])} - {__formatDateMM_DD_YYYY_US(dateRanges[1])}</p>
                </>;
            break;
        }
        case 'name': {
            filterTagBody =
                <>
                    <strong>Name</strong> &nbsp; includes: &quot;<p className="filter-text">{filter.value}</p>&quot;
                </>;
            break;
        }
        case 'owner': {
            filterTagBody =
                <>
                    <strong>Owner</strong> &nbsp; <p className="filter-text">{filter.value}</p>
                </>;
            break;
        }
        case 'reviewed': {
            filterTagBody =
                <>
                    <strong>Show:</strong> &nbsp; <p className="filter-text">{filter.value === 'true' ? 'Reviewed' : 'Un-reviewed'}</p>
                </>;
            break;
        }
        case 'status': {
            filterTagBody =
                <>
                    <strong>Status:</strong> &nbsp; <p className="filter-text">{filter.value}</p>
                </>;
            break;
        }
        case 'requests': {
            filterTagBody =
                <>
                    <strong>Domains</strong> &nbsp; includes: &quot;<p className="filter-text">{filter.value}</p>&quot;
                </>;
            break;
        }
        case 'uri': {
            filterTagBody =
                <>
                    <strong>URL</strong> &nbsp; includes: &quot;<p className="filter-text">{filter.value}</p>&quot;
                </>;
            break;
        }
        case 'traffic_source': {
            filterTagBody =
                <>
                    <strong>Traffic Source</strong> &nbsp; includes: &quot;<p className="filter-text">{filter.value}</p>&quot;
                </>;
            break;
        }
        case 'domain': {
            filterTagBody =
                <>
                    <strong>Domain:</strong> &nbsp; &quot;<p className="filter-text">{filter.value}</p>&quot;
                </>;
            break;
        }
        case 'page_type': {
            filterTagBody =
                <div className="page-type-filter-tag">
                    <strong>Page Type:</strong> &nbsp; <p className="filter-text page-type">{filter.value}</p>
                    {(filter.confidenceLevel !== 'all' && filter.confidenceLevel) &&
                        <>
                            <div className="confidence-level">
                                <strong> Confidence:</strong> &nbsp; <p className="filter-text">{__capitalizeFirstLetter(filter.confidenceLevel)}</p>
                            </div>
                        </>
                    }
                </div>;

            break;
        }
        case 'phrases': {
            filterTagBody =
                <>
                    <strong>Phrases:</strong> &nbsp; <p className="filter-text">{filter.value}</p>
                </>;
            break;
        }
        case 'selected': {
            filterTagBody =
                <>
                    <strong>Show:</strong> &nbsp; <p className="filter-text">{filter.value === 'true' ? 'Selected' : 'Unselected'}</p>
                </>;
            break;
        }
        case 'offset':
        case 'limit':
        case 'sort': {
            filterTagBody =
                <div style={{ display: 'none' }}></div>;
            break;
        }
        default: {
            filterTagBody =
                <>
                    {filter.name} <span style={{ fontSize: ".8em" }} className="italicized">contains</span> <p className="filter-text">{filter.value}</p>
                </>;
            break;
        }
    }

    const dataTestId = 'filter-tag-' + filter.name.split(' ').join('-');

    return (
        <div className={"active-filter-tag label " + (filter.name == "offset" || filter.name == "sort" ? "no-filter-display" : "")} ref={tagRef} data-testid={dataTestId}>
            {filterTagBody}
            <a className="remove-filter-button" onClick={removeFilter}>
                <RemoveIcon width={8} />
            </a>
        </div>
    );
};

export default memo(FilterTag);